import { KULEWEBVIEW_ANDROID, KULEWEBVIEW_IOS } from '@/config/constant'
import TGASDK from '@/config/TGASDK'

const useThemeBasis = () => {
  return {
    lightHeader:
      ['regular', 'navy-blue', 'orange', 'lavender'].indexOf(TGASDK.context.appConfig.defaultTheme) >= 0 &&
      KULEWEBVIEW_IOS,
    lightAndroidHeader:
      ['regular', 'navy-blue', 'orange', 'lavender'].indexOf(TGASDK.context.appConfig.defaultTheme) >= 0 &&
      KULEWEBVIEW_ANDROID,
    lightIosHeader:
      ['regular', 'navy-blue', 'orange', 'lavender'].indexOf(TGASDK.context.appConfig.defaultTheme) >= 0 &&
      KULEWEBVIEW_IOS
  }
}

export default useThemeBasis
